import cx from 'clsx';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { getNodeSensors } from '@helpers/getNodeSensors';
import { calcSensorHex } from '@helpers/helper';

import useTranslation from '@hooks/useTranslation';

import type { IEquipmentDetails } from '@model/equipmentDetails';

import SensorsAssociatedSkeleton from './SensorsAssociatedSkeleton';
import style from './style.module.scss';

interface IProps {
  detailsData?: IEquipmentDetails;
  isEquipmentLoading?: boolean;
}

const SensorsAssociated: React.FC<IProps> = ({ detailsData, isEquipmentLoading }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sensors = detailsData?.sensorPoints || [];

  const nodeSensors = getNodeSensors(sensors);

  return (
    <>
      <div className={style.blockTitle}>{t('Associated sensors')}</div>
      <div className={style.blockContainer}>
        <table className={style.associatedSensorsTable} cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th>{t('Port')}</th>
              <th>{t('Sensor HEX code')}</th>
              <th>{t('Component')}</th>
              <th>{t('Equipment')}</th>
              <th>{t('Version')}</th>
            </tr>
          </thead>
          <tbody>
            {isEquipmentLoading && <SensorsAssociatedSkeleton />}
            {!isEquipmentLoading &&
              nodeSensors.map((sensor, index) =>
                !sensor ? (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={cx(style.sensorsTableBodyCell, style.noSensorText)} colSpan={5}>
                      {t('No connected sensor')}
                    </td>
                  </tr>
                ) : (
                  <tr key={index} className={style.sensorsTableBodyRow}>
                    <td>{sensor.sensor.position}</td>
                    <td>
                      {sensor.component !== 'Tachometer'
                        ? calcSensorHex(sensor.sensor_id, sensor.hardware_id)
                        : ''}
                    </td>
                    <td
                      className={cx({
                        [style.tachometerCell]: sensor.component === 'Tachometer',
                      })}
                      onClick={() => {
                        if (sensor.component === 'Tachometer') {
                          navigate(`/customer/${customerId}/tachometer/${sensor.id}`);
                        }
                      }}
                    >
                      {sensor.component}
                    </td>
                    <td
                      className={style.cellEquipmentName}
                      onClick={() =>
                        navigate(`/customer/${customerId}/sensors/${sensor.equipment_id}/list`, {
                          state: { prevPage: pathname },
                        })
                      }
                    >
                      {sensor.component !== 'Tachometer' ? sensor.equipment?.name : ''}
                    </td>
                    <td>{sensor.component !== 'Tachometer' ? sensor.sensor.part_number : ''}</td>
                  </tr>
                ),
              )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SensorsAssociated;
